import { Storage } from "@faire/web/common/Storage";
import { IOption } from "@faire/web/slate/Input/Dropdown/index";
import { computed } from "mobx";

import { ICountry } from "@faire/retailer/views/apply/MakerApplication/MakerSignUpState";

interface IInboundApplicationFormData {
  companyName?: string;
  url?: string;
  email?: string;
  stockists?: number;
  numProducts?: number;
  categoryOption?: IOption;
  country: ICountry;
  phoneNumber?: string;
}

export const MAKER_APPLICATION_DEFAULT_FORM_DATA: IInboundApplicationFormData =
  {
    country: {
      isoCode: "",
      displayName: "",
    },
  };

export class MakerApplicationDataFormStorage {
  private FORM_DATA_KEY = "MAKER_INBOUND_APPLICATION_FORM_DATA";

  initialize = (defaultData?: IInboundApplicationFormData) => {
    if (!this.formData && defaultData) {
      this.setData(defaultData);
    }
  };

  @computed
  get formData(): IInboundApplicationFormData | undefined {
    const data = Storage.local.getItem(this.FORM_DATA_KEY);
    return data ? JSON.parse(data) : undefined;
  }

  setData = (data: IInboundApplicationFormData) => {
    Storage.local.setItem(this.FORM_DATA_KEY, JSON.stringify(data));
  };

  clearData = () => {
    if (this.formData) {
      Storage.local.removeItem(this.FORM_DATA_KEY);
    }
  };
}
